// Theme: imperial-black
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'imperial-black',
  name: 'IMPERIAL BLACK',
  tagline: 'IMPERIAL BLACK',
  description: 'Luxury minimal. Preto profundo com azul acinzentado e acabamento premium.',
  category: 'premium-status',
  tier: 'legendary',
  basePrice: 5250,
  swatches: ['#040507', '#0D1118', '#8C9AAF', '#E7ECF3'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '14px',
      '--shadow-card': '0 10px 24px rgba(0, 0, 0, 0.34)',
      '--shadow-card-active': '0 12px 28px color-mix(in srgb, var(--primary) 24%, transparent)'
    },
    shellClasses: 'font-sans theme-imperial-black'
  },
  colorVars: {
    '--accent': '#8C9AAF',
    '--accent-foreground': '#040507',
    '--background': '#040507',
    '--border': '#1B2533',
    '--card': '#0D1118',
    '--card-border-active': 'rgba(140, 154, 175, 0.46)',
    '--card-completed': '#0A0E14',
    '--card-foreground': '#E7ECF3',
    '--card-glow': 'rgba(140, 154, 175, 0.09)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#040507',
    '--foreground': '#E7ECF3',
    '--hold-fill': '#8C9AAF',
    '--input': '#232F40',
    '--modal-bg': '#040507',
    '--modal-border': '#1B2533',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 24px rgba(0, 0, 0, 0.34)',
    '--muted': '#232F40',
    '--muted-foreground': '#C4CDD8',
    '--nav-active': '#8C9AAF',
    '--nav-bg': '#0D1118',
    '--popover': '#0D1118',
    '--popover-foreground': '#E7ECF3',
    '--primary': '#8C9AAF',
    '--primary-foreground': '#040507',
    '--ring': '#8C9AAF',
    '--secondary': '#232F40',
    '--secondary-foreground': '#E7ECF3',
    '--streak': '#8C9AAF',
    '--success': '#22c55e',
    '--success-foreground': '#040507',
    '--xp': '#8C9AAF',
    '--xp-bg': '#0D1118'
  },
  resolvedVars: {
    '--accent': '#8C9AAF',
    '--accent-foreground': '#040507',
    '--accent-foreground-hsl': '220 27% 2%',
    '--accent-foreground-oklch': 'from #040507 l c h',
    '--accent-hsl': '216 18% 62%',
    '--accent-oklch': 'from #8C9AAF l c h',
    '--background': '#040507',
    '--background-hsl': '220 27% 2%',
    '--background-oklch': 'from #040507 l c h',
    '--border': '#1B2533',
    '--border-hsl': '215 31% 15%',
    '--border-oklch': 'from #1B2533 l c h',
    '--border-w': '1px',
    '--card': '#0D1118',
    '--card-border-active': 'rgba(140, 154, 175, 0.46)',
    '--card-completed': '#0A0E14',
    '--card-completed-hsl': '216 33% 6%',
    '--card-completed-oklch': 'from #0A0E14 l c h',
    '--card-foreground': '#E7ECF3',
    '--card-foreground-hsl': '215 33% 93%',
    '--card-foreground-oklch': 'from #E7ECF3 l c h',
    '--card-glow': 'rgba(140, 154, 175, 0.09)',
    '--card-hsl': '218 30% 7%',
    '--card-oklch': 'from #0D1118 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#040507',
    '--destructive-foreground-hsl': '220 27% 2%',
    '--destructive-foreground-oklch': 'from #040507 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#E7ECF3',
    '--foreground-hsl': '215 33% 93%',
    '--foreground-oklch': 'from #E7ECF3 l c h',
    '--hold-fill': '#8C9AAF',
    '--hold-fill-hsl': '216 18% 62%',
    '--hold-fill-oklch': 'from #8C9AAF l c h',
    '--input': '#232F40',
    '--input-hsl': '215 29% 19%',
    '--input-oklch': 'from #232F40 l c h',
    '--modal-bg': '#040507',
    '--modal-bg-hsl': '220 27% 2%',
    '--modal-bg-oklch': 'from #040507 l c h',
    '--modal-border': '#1B2533',
    '--modal-border-hsl': '215 31% 15%',
    '--modal-border-oklch': 'from #1B2533 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 24px rgba(0, 0, 0, 0.34)',
    '--muted': '#232F40',
    '--muted-foreground': '#C4CDD8',
    '--muted-foreground-hsl': '213 20% 81%',
    '--muted-foreground-oklch': 'from #C4CDD8 l c h',
    '--muted-hsl': '215 29% 19%',
    '--muted-oklch': 'from #232F40 l c h',
    '--nav-active': '#8C9AAF',
    '--nav-active-hsl': '216 18% 62%',
    '--nav-active-oklch': 'from #8C9AAF l c h',
    '--nav-bg': '#0D1118',
    '--nav-bg-hsl': '218 30% 7%',
    '--nav-bg-oklch': 'from #0D1118 l c h',
    '--popover': '#0D1118',
    '--popover-foreground': '#E7ECF3',
    '--popover-foreground-hsl': '215 33% 93%',
    '--popover-foreground-oklch': 'from #E7ECF3 l c h',
    '--popover-hsl': '218 30% 7%',
    '--popover-oklch': 'from #0D1118 l c h',
    '--primary': '#8C9AAF',
    '--primary-foreground': '#040507',
    '--primary-foreground-hsl': '220 27% 2%',
    '--primary-foreground-oklch': 'from #040507 l c h',
    '--primary-hsl': '216 18% 62%',
    '--primary-oklch': 'from #8C9AAF l c h',
    '--radius': '14px',
    '--ring': '#8C9AAF',
    '--ring-hsl': '216 18% 62%',
    '--ring-oklch': 'from #8C9AAF l c h',
    '--secondary': '#232F40',
    '--secondary-foreground': '#E7ECF3',
    '--secondary-foreground-hsl': '215 33% 93%',
    '--secondary-foreground-oklch': 'from #E7ECF3 l c h',
    '--secondary-hsl': '215 29% 19%',
    '--secondary-oklch': 'from #232F40 l c h',
    '--shadow-card': '0 10px 24px rgba(0, 0, 0, 0.34)',
    '--shadow-card-active': '0 12px 28px color-mix(in srgb, var(--primary) 24%, transparent)',
    '--streak': '#8C9AAF',
    '--streak-hsl': '216 18% 62%',
    '--streak-oklch': 'from #8C9AAF l c h',
    '--success': '#22c55e',
    '--success-foreground': '#040507',
    '--success-foreground-hsl': '220 27% 2%',
    '--success-foreground-oklch': 'from #040507 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(216 18% 62% / 0.15)',
    '--xp': '#8C9AAF',
    '--xp-bg': '#0D1118',
    '--xp-bg-hsl': '218 30% 7%',
    '--xp-bg-oklch': 'from #0D1118 l c h',
    '--xp-hsl': '216 18% 62%',
    '--xp-oklch': 'from #8C9AAF l c h'
  }
}
